// extracted by mini-css-extract-plugin
export default {"root":"_1hcgh","expanded":"_3Xpv8"};